//Components
import ErrorPhone from '../../components/error/error_phone_version'
import PhoneHeader from '../../components/phoneresponsive/phone_header'
import Projects from '../../components/main/projects'
import Project from '../../components/main/project'
import PhoneModal from '../../components/phoneresponsive/phone_modal'
import PhoneFooter from '../../components/phoneresponsive/phone_footer'

//Basic
import { useState, useEffect } from 'react'
import { useFetch } from '../../hooks/fetch'

//Language
import { useLanguage } from '../../context/language_context'
import { translate } from '../../utils/translate'

//Image
import BottomCV from '../../assets/cv_bottom.gif'


function CvEducation() {

    // ========================================
    // LANGUAGE
    // ========================================

    const { language } = useLanguage()


    // ========================================
    // STATES
    // ========================================

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [educationExperiences, setEducationExperiences] = useState([])

    const [selectedExperienceName, setSelectedExperienceName] = useState('')
    const [selectedExperiencePlace, setSelectedExperiencePlace] = useState('')
    const [selectedExperienceCalendar, setSelectedExperienceCalendar] = useState('')
    const [selectedExperienceDescription, setSelectedExperienceDescription] = useState('')
    const [selectedExperienceReward, setSelectedExperienceReward] = useState('')

    const [selectedExperienceStrongskills, setSelectedExperienceStrongskills] = useState('')
    const [selectedExperienceGoodskills, setSelectedExperienceGoodskills] = useState('')
    const [selectedExperienceAverageskills, setSelectedExperienceAverageskills] = useState('')
    const [selectedExperienceWeakskills, setSelectedExperienceWeakskills] = useState('')

    const [selectedExperienceTools, setSelectedExperienceTools] = useState([])

    const [selectedExperienceSearch, setSelectedExperienceSearch] = useState('')


    // ========================================
    // MODAL
    // ========================================

    const openModal = (
        name,
        job_place,
        job_calendar,
        job_description,
        reward,
        strong_skills,
        good_skills,
        average_skills,
        weak_skills,
        tools,
        search
    ) => {

        setSelectedExperienceName(
            translate(name, language)
        )

        setSelectedExperiencePlace(
            translate(job_place, language)
        )

        setSelectedExperienceCalendar(
            translate(job_calendar, language)
        )

        setSelectedExperienceDescription(
            translate(job_description, language)
        )

        setSelectedExperienceReward(
            translate(reward, language)
        )

        setSelectedExperienceStrongskills(
            translate(strong_skills, language)
        )

        setSelectedExperienceGoodskills(
            translate(good_skills, language)
        )

        setSelectedExperienceAverageskills(
            translate(average_skills, language)
        )

        setSelectedExperienceWeakskills(
            translate(weak_skills, language)
        )

        setSelectedExperienceTools(
            (tools || []).map((tool) =>
                translate(tool, language)
            )
        )

        setSelectedExperienceSearch(
            translate(search, language)
        )

        setIsModalOpen(true)
    }


    const closeModal = () => {
        setIsModalOpen(false)
    }


    // ========================================
    // DATA
    // ========================================

    const { data, error } = useFetch(
        `/db/experiences.json?v=${Date.now()}`
    )


    useEffect(() => {

        if (data) {

            const education = data.filter(
                (experience) =>
                    experience.type === 'education'
            )

            setEducationExperiences(education)
        }

    }, [data])


    // ========================================
    // LOADING / ERROR
    // ========================================

    if (!data) {
        return (
            <span>
                {language === 'fr'
                    ? 'Chargement en cours...'
                    : 'Loading...'}
            </span>
        )
    }


    if (error) {
        return (
            <span>
                {language === 'fr'
                    ? 'Il y a un problème'
                    : 'Something went wrong'}
            </span>
        )
    }


    // ========================================
    // RENDER
    // ========================================

    return (

        <div className="phone_projects cv_phone_projects">

            <ErrorPhone />

            <PhoneHeader />


            <p className='phone_projects_title'>
                {language === 'fr'
                    ? 'Formation'
                    : 'Education'}
            </p>


            <Projects
                title={
                    language === 'fr'
                        ? 'Formation'
                        : 'Education'
                }
            >

                {educationExperiences.map((experience) => (

                    <Project
                        key={experience.id}

                        name={translate(
                            experience.name,
                            language
                        )}

                        onOpen={() =>
                            openModal(
                                experience.name,
                                experience.job_place,
                                experience.job_calendar,
                                experience.job_description,
                                experience.reward,
                                experience.strong_skills,
                                experience.good_skills,
                                experience.average_skills,
                                experience.weak_skills,
                                experience.tools,
                                experience.search
                            )
                        }

                        isMainPage={true}
                    />

                ))}


                <img
                    src={BottomCV}
                    className='phone_bottom_projects'
                    alt=""
                />

            </Projects>


            {isModalOpen && (

                <PhoneModal
                    closeModal={closeModal}

                    name={selectedExperienceName}

                    job_place={selectedExperiencePlace}

                    job_calendar={selectedExperienceCalendar}

                    job_description={selectedExperienceDescription}

                    reward={selectedExperienceReward}

                    strong_skills={selectedExperienceStrongskills}

                    good_skills={selectedExperienceGoodskills}

                    average_skills={selectedExperienceAverageskills}

                    weak_skills={selectedExperienceWeakskills}

                    tools={selectedExperienceTools}

                    search={selectedExperienceSearch}

                    experiences={educationExperiences}
                />

            )}


            <PhoneFooter />

        </div>

    )
}


export default CvEducation